import { render, staticRenderFns } from "./ReciboConformidad.vue?vue&type=template&id=05c4ff7a&"
import script from "./ReciboConformidad.vue?vue&type=script&lang=js&"
export * from "./ReciboConformidad.vue?vue&type=script&lang=js&"
import style0 from "./ReciboConformidad.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports